import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import UploadIcon from "@mui/icons-material/Upload";
import FieldHeader from "./FieldHeader";
import UploadedOtherDocumentCard from "./UploadedOtherDocumentCard";

const Input = styled("input")({
	display: "none",
});

const SubmitComponent = ({
	handleChange,
	url,
	filename,
	fileSize,
	fileType,
}) => {
	return (
		<Box sx={{ marginBottom: "3rem" }}>
			<FieldHeader
				header="Other Document Uploads"
				subHeader="Upload other documents, accepted formats include .jpg, .jpeg, .png, and .pdf documents and max size 2mb"
			/>
			<Box>
				<Box
					sx={{
						backgroundColor: "#fff",
						padding: "1.5rem",
						color: "#718096",
					}}
				>
					{url && (
						<UploadedOtherDocumentCard
							image={url}
							filename={filename}
							fileSize={fileSize}
							fileType={fileType}
						/>
					)}
					<label htmlFor="contained-document-button-file">
						<Input
							id="contained-document-button-file"
							type="file"
							accept="image/*,application/pdf"
							onChange={handleChange}
						/>
						<Button
							variant="contained"
							color="success"
							sx={{ mt: "1rem" }}
							component="span"
							endIcon={<UploadIcon />}
						>
							add new document
						</Button>
					</label>
				</Box>
			</Box>
		</Box>
	);
};

export default SubmitComponent;
